import * as React from "react";
import { SVGProps } from "react";
export const HouseFillIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M3 15.945V7.72477C3 7.44997 3.06116 7.18962 3.18349 6.94373C3.30581 6.69786 3.48114 6.48522 3.70948 6.30581L8.99388 2.34251C9.32008 2.11417 9.67074 2 10.0459 2C10.421 2 10.7717 2.11417 11.0979 2.34251L16.3823 6.30581C16.6106 6.48522 16.7859 6.69786 16.9083 6.94373C17.0306 7.18962 17.0917 7.44997 17.0917 7.72477V15.945C17.0917 16.5101 16.8905 16.9939 16.4881 17.3963C16.0856 17.7988 15.6018 18 15.0367 18H12.6881C12.4385 18 12.2294 17.9156 12.0606 17.7468C11.8917 17.578 11.8073 17.3688 11.8073 17.1193V12.422C11.8073 12.1725 11.7231 11.9633 11.5547 11.7945C11.3863 11.6257 11.1777 11.5413 10.9288 11.5413H9.17157C8.92263 11.5413 8.71254 11.6257 8.54128 11.7945C8.37003 11.9633 8.2844 12.1725 8.2844 12.422V17.1193C8.2844 17.3688 8.2 17.578 8.03119 17.7468C7.86239 17.9156 7.65321 18 7.40367 18H5.05505C4.48991 18 4.00612 17.7988 3.60367 17.3963C3.20122 16.9939 3 16.5101 3 15.945Z"
            fill="currentColor"
        />
    </svg>
);
HouseFillIcon.displayName = "HouseFillIcon";
